import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Checkbox } from 'ncoded-component-library';
import useCallbackRef from 'hooks/useCallbackRef';
import { OverlayRef } from 'ncoded-component-library/build/components/atoms/Overlay/Overlay.component';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import OrganizeRequestedFilesModal from '../OrganizeRequestedFilesModal';
import {
  DataRoomRFI,
  DataRoomRFICategory,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';

import './AutomaticallyAddFilesToDr.styles.scss';

type AutomaticallyAddFilesToDrProps = {
  className?: string;
  dataRoomRfiId: string;
  automaticFileUploadToDataRoom?: boolean;
  dataRoomRFICategories: DataRoomRFICategory[];
  onRfiUpdate: (updatedRfi: Partial<DataRoomRFI>) => void;
};

const AutomaticallyAddFilesToDr: React.FC<AutomaticallyAddFilesToDrProps> = (
  props,
) => {
  const {
    className,
    dataRoomRfiId,
    automaticFileUploadToDataRoom,
    dataRoomRFICategories,
    onRfiUpdate,
  } = props;

  const [organizeFileModal, organizeFileModalRef] =
    useCallbackRef<OverlayRef>();

  const { popServerError } = useContext(PopNotificationsContext);

  const optOutOfAutomaticUpload = !automaticFileUploadToDataRoom;

  const classes = classNames('automatically-add-files-to-dr', className);

  const { t } = useTranslation();

  const onOptOut = useCallback(
    async (optOutOfAutomaticUpload: boolean) => {
      try {
        const { data } = await dataRoomApi.rfi.patchRfi(dataRoomRfiId, {
          automaticFileUploadToDataRoom: !optOutOfAutomaticUpload,
        });

        onRfiUpdate(data);
      } catch (e) {
        popServerError(e);
      }
    },
    [dataRoomRfiId, onRfiUpdate, popServerError],
  );

  return (
    <div className={classes}>
      <div>
        <p>
          {t('allFilesAutomaticallyUploaded')}{' '}
          <Trans
            i18nKey={'changeDestination'}
            components={{
              button: (
                <Button variant="link" onClick={organizeFileModal?.open} />
              ),
            }}
          />
          <OrganizeRequestedFilesModal
            ref={organizeFileModalRef}
            dataRoomRfiId={dataRoomRfiId}
            dataRoomRFICategories={dataRoomRFICategories}
            onRfiUpdate={onRfiUpdate}
          />
        </p>

        <Checkbox
          checked={optOutOfAutomaticUpload}
          label={t('optOutAutomaticFileUpload')}
          onChange={(value) => onOptOut(!!value)}
        />
      </div>
    </div>
  );
};

export default AutomaticallyAddFilesToDr;
